/* global femcare */
/**
 * Pub Sub pattern for component communication
 */

femcare.shared.pubsub = {
    subscribers: {},
    /**
     * Send data to all subscribers for this event
     * @param {string} event - event name
     * @param {object} data - holder for data
     */
    publish: function (event, data) {
        if (!this.subscribers[event]) {
            return;
        }

        this.subscribers[event].forEach(function (subscriberCallback) {
            subscriberCallback(data);
        });
    },

    /**
     * Subscribe for event and wait for incoming data
     * @param {string} event - string represent event name
     * @param {function} callback - execute function with provided data
     * @returns {function} unsubscribe from event
     */
    subscribe: function (event, callback) {
        var index;

        if (!this.subscribers[event]) {
            this.subscribers[event] = [];
        }

        index = this.subscribers[event].push(callback) - 1;

        return {
            unsubscribe: function () {
                this.subscribers[event].splice(index, 1);
            }
        };
    }
};
